import { type RefObject, useEffect, useState } from 'react';

/**
 * True once the element has entered the viewport (Webflow's "scroll into view" trigger with a
 * 0% offset). `rootMargin` shifts the trigger line, e.g. "0px 0px -50% 0px" for "top 50%".
 */
export function useInView(ref: RefObject<Element | null>, { once = true, rootMargin = '0px' } = {}): boolean {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry?.isIntersecting) {
          setInView(true);
          if (once) io.disconnect();
        } else if (!once) setInView(false);
      },
      { rootMargin },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref, once, rootMargin]);
  return inView;
}
